import styled from "styled-components";

interface ToastBoxProps {
	width?: number;
	height?: number;
	fontSize?: number;
}
export const ToastBox = styled.div`
	position: fixed;
	z-index: 2;
	left: 0;
	top: 0;
	bottom: 0;
	right: 0;
	margin: auto;
	width: ${(props: ToastBoxProps) => `${props?.width || 227}px`};
	height: ${(props: ToastBoxProps) => `${props?.height || 43}px`};
	line-height: ${(props: ToastBoxProps) => `${props?.height || 43}px`};
	background-color: rgba(0, 0, 0, 0.7);
	border-radius: 2px;
	font-size: ${(props: ToastBoxProps) => `${props?.fontSize || 14}px`};
	text-align: center;
	color: #ffffff;
`;
